import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const WhatYouGetSettings = () => {
  const [form, setForm] = useState({
    titleLine1: '',
    titleLine2: '',
    descriptionText: '',
    ctaLabel: '',
    ctaPath: '',
    statsText: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/what-you-get`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { whatYouGet } = res.data;
        if (whatYouGet) {
          setForm({
            titleLine1: whatYouGet.titleLine1 || '',
            titleLine2: whatYouGet.titleLine2 || '',
            descriptionText: whatYouGet.descriptionText || '',
            ctaLabel: whatYouGet.ctaLabel || '',
            ctaPath: whatYouGet.ctaPath || '',
            statsText: Array.isArray(whatYouGet.stats)
              ? whatYouGet.stats.map((s) => `${s.number}||${s.label}`).join('\n')
              : '',
          });
        }
      } catch {
        // ignore
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');

    const token = localStorage.getItem('adminToken');
    if (!token) {
      setError('انتهت صلاحية الجلسة، برجاء تسجيل الدخول مرة أخرى.');
      setSaving(false);
      return;
    }

    const stats = form.statsText
      ? form.statsText
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean)
          .map((line) => {
            const [number, label] = line.split('||');
            return {
              number: (number || '').trim(),
              label: (label || '').trim(),
            };
          })
      : [];

    try {
      await axios.put(
        `${API_BASE_URL}/api/admin/what-you-get`,
        {
          ...form,
          stats,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSuccess('تم حفظ إعدادات قسم ماذا ستحصل معنا بنجاح.');
    } catch (err) {
      const message = err.response?.data?.message || 'حدث خطأ أثناء الحفظ.';
      setError(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p>جاري تحميل إعدادات هذا القسم...</p>;
  }

  return (
    <div className="admin-section">
      <h2 className="admin-section-title">إعدادات قسم ماذا ستحصل معنا</h2>
      <p className="admin-section-subtitle">
        يمكنك هنا تعديل العنوان، النص، زر الدعوة لاتخاذ إجراء، وبطاقات الإحصائيات في قسم "في نبض
        كير نجعل رحلة منتجك إلى السوق أكثر سلاسة ونجاحاً".
      </p>

      {error && <div className="admin-section-error">{error}</div>}
      {success && <div className="admin-section-success">{success}</div>}

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>العنوان - السطر الأول</label>
          <input
            type="text"
            value={form.titleLine1}
            onChange={(e) => updateField('titleLine1', e.target.value)}
            placeholder="في نبض كير نجعل رحلة منتجك إلى السوق"
          />
        </div>
        <div className="admin-field">
          <label>العنوان - السطر الثاني</label>
          <input
            type="text"
            value={form.titleLine2}
            onChange={(e) => updateField('titleLine2', e.target.value)}
            placeholder="أكثر سلاسة ونجاحاً"
          />
        </div>
      </div>

      <div className="admin-field">
        <label>النص الوصفي</label>
        <input
          type="text"
          value={form.descriptionText}
          onChange={(e) => updateField('descriptionText', e.target.value)}
          placeholder="نحن في نبض كير لا نقدم مجرد استشارات، بل نمنحك راحة البال..."
        />
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>نص زر الدعوة لاتخاذ إجراء (CTA)</label>
          <input
            type="text"
            value={form.ctaLabel}
            onChange={(e) => updateField('ctaLabel', e.target.value)}
            placeholder="ابدأ رحلتك الآن"
          />
        </div>
        <div className="admin-field">
          <label>مسار زر الدعوة لاتخاذ إجراء (CTA path)</label>
          <input
            type="text"
            value={form.ctaPath}
            onChange={(e) => updateField('ctaPath', e.target.value)}
            placeholder="/contact"
          />
        </div>
      </div>

      <div className="admin-field">
        <label>بطاقات الإحصائيات (كل سطر: الرقم ثم || ثم النص)</label>
        <textarea
          rows={6}
          value={form.statsText}
          onChange={(e) => updateField('statsText', e.target.value)}
          style={{ resize: 'vertical' }}
          placeholder={`98%||نسبة قبول الملفات\n500+||عميل نالوا ثقتنا\n100%||امتثال للأنظمة\n24/7||دعم فني مستمر`}
        />
        <small>مثال: 98%||نسبة قبول الملفات</small>
      </div>

      <div className="admin-actions">
        <button
          type="button"
          className="admin-btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
        </button>
      </div>
    </div>
  );
};

export default WhatYouGetSettings;

